import React, { useState } from "react";
import PropTypes from "prop-types";
//import useStyles  from './style';
//import { Hidden, Paper, Tab, Tabs } from '@material-ui/core';
import { getSalesHeader, timeStampFormat } from "../../../utils/common/index";
import TabPanel from "../../../containers/rechargeSales/sales/component/tabPanel";
import SalesViews from "../../../views/deviceSales/sales";
import PrimarySales from "../../../containers/deviceSales/sales/component/PrimarySales";
import MobileSalesTilePicker from "../../../components/MobileSalesTilePicker";

const RenderPanel = (props) => {
  let { tileName, ...other } = props;
  return <PrimarySales data="" tileName={tileName} {...other} />;
};

RenderPanel.propTypes = {
  tileName: PropTypes.string,
};

const Sales = (props) => {
  //const classes = useStyles();

  const [sideValue, setSideValue] = useState(0);
  // const [rsdOption,setRsdOption]=useState('rsd1');
  const { timeStampArr } = props;
  props.data &&
    props.data.sort((a, b) => {
      return a.tileId - b.tileId;
    });

  const sideHandleChangeDesktop = (tile, event) => {
    setSideValue(event);
  };
  const sideHandleChangeMobile = (event) => {
    setSideValue(event.target.value);
  };

  const activeTiles = props.data.filter((tile) => tile.isTileActive === "Y");
  const length = activeTiles.length;

  let ts = "";
  const currSelectedTile = activeTiles[sideValue]?.tileName;
  if (timeStampArr) {
    ts = timeStampArr.filter((data) => {
      return data?.tilename?.toLowerCase() === currSelectedTile?.toLowerCase();
    });
    ts = timeStampFormat(
      ts && ts[0] && ts[0].tileTimestamp && ts[0].tileTimestamp?.split(".")[0]
    );
  }

  return (
    // <SalesViews
    //   section={props.section}
    //   data={props.data}
    //   filterValue={props.filterValue}
    //   startDate={props.startDate}
    //   endDate={props.endDate}
    //   moduleName={props.moduleName}
    //   sideHandleChangeMobile={sideHandleChangeMobile}
    //   sideHandleChangeDesktop={sideHandleChangeDesktop}
    //   sideValue={setSideValue}
    //   ts={ts}
    //   length={length}
    // />
    <div
      className="whitebox wow fadeInUp"
      data-wow-delay=".6s"
      data-wow-duration="0.7s"
      data-cy="Sales"
    >
      <div className="subtitlebox">
        <div className="subtitleboxChild">{props?.section}</div>
        {/* <div>{ts}</div> */}
      </div>
      <div className="tabcontbox">
        <div className="row recharge-sales-tab-row">
          <div className="col-12 col-md-4 d-block d-sm-none recharge-sales-tile-select-wrap">
            <MobileSalesTilePicker
              activeTiles={activeTiles}
              sideValue={Number(sideValue)}
              onSelectIndex={setSideValue}
            />
          </div>
          <div className="d-none d-sm-block col-md-3">
            <div
              className={
                length === 5
                  ? "rsdlist mt-2"
                  : length === 4
                  ? "rsdlist mt-4"
                  : "rsdlist mt-5"
              }
            >
              <ul>
                {props.data
                  .filter((tile) => tile.isTileActive === "Y")
                  .map((tile, index) => {
                    const header = getSalesHeader(tile.tileName);
                    return (
                      <li key={index}>
                        <a
                          href={`#rsd${index + 1}`}
                          onClick={() => {
                            sideHandleChangeDesktop(tile, index);
                          }}
                          className={sideValue === index ? "active" : ""}
                        >
                          {tile.tileName + header}
                        </a>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-9">
            {props.data
              .filter((tile) => tile.isTileActive === "Y")
              .map((tile, index) => (
                <TabPanel key={index} value={parseInt(sideValue)} index={index}>
                  <RenderPanel
                    tileName={tile.tileName.split(" ")[0]}
                    url={tile.tileEndPointUrl}
                    csvUrl={tile.csvEndPointUrl}
                    isCsvActive={tile.isCsvActive}
                    filterValue={props.filterValue}
                    data={props.data}
                    startDate={props.startDate}
                    endDate={props.endDate}
                    moduleName={props.moduleName}
                    id={index + 1}
                    section={props.section}
                    viewName={props.viewName}
                  />
                </TabPanel>
              ))}
          </div>
        </div>
      </div>

      <div className="card-timestamp border-top mt-2">
        <i className="fa fa-history mr-2 mt-2 mb-0"></i>
        Updated on {ts}
      </div>
    </div>
  );
};

export default Sales;
